import { render, staticRenderFns } from "./DynamicFooter.vue?vue&type=template&id=2fb9b79f&scoped=true&"
import script from "./DynamicFooter.vue?vue&type=script&lang=js&"
export * from "./DynamicFooter.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFooter.vue?vue&type=style&index=0&id=2fb9b79f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9b79f",
  null
  
)

export default component.exports